import { render, staticRenderFns } from "./GroupImages.vue?vue&type=template&id=4ac97f4c&scoped=true"
import script from "./GroupImages.vue?vue&type=script&lang=js"
export * from "./GroupImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac97f4c",
  null
  
)

export default component.exports